// extracted by mini-css-extract-plugin
export default {"chart_icon":"HomeworkPerformanceViewResults_chart_icon__uM1OS"};